import React, { useContext, useEffect } from "react";
import { MenuContext } from "../contexts/MenuContext";
import "./styles/Selector.css";
import CloseIcon from "@mui/icons-material/Close";
import ExpSongCard from "./ExpSongCard";

function Selector() {
  const { checked, setChecked, expanded, setExpanded } =
    useContext(MenuContext);

  function switchexp() {
    setExpanded(!expanded);
  }

  return (
    <div
      className={`expander--container ${
        expanded ? "expanded" : "not--expanded"
      }`}
    >
      <div className="sel--header">
        <button
          className="sel--close"
          onClick={() => {
            setChecked([]);
            setExpanded(false);
          }}
        >
          <CloseIcon style={{ fill: "#F6FAFF" }} fontSize="large" />
        </button>
        <div className={`sel--expander ${expanded ? "exped" : "not--exped"}`}>
          <button onClick={switchexp}>
            {Object.values(checked).length}{" "}
            {Object.values(checked).length > 1 ? " songs" : "song"} selected
          </button>
        </div>
        <button className="sel--play">Play</button>
      </div>

      {/* Show this when Selector is expanded */}
      {expanded === true && (
        <div className="sel--song--container">
          {checked &&
            Object.keys(checked).length > 0 &&
            checked.map((item) => {
              return <ExpSongCard key={item.id} selData={item} />;
            })}
        </div>
      )}
    </div>
  );
}

export default Selector;
